(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/shared/components/skeleton.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/shared/components/skeleton.js');
'use strict';

const {
  ReactPaper
} = svs.ui;

const Skeleton = _ref => {
  let {
    bottomMargin = 0,
    boxHeight = 1,
    boxWidthProcent = 100,
    topMargin = 0
  } = _ref;
  return (
    React.createElement(ReactPaper, {
      isFlat: true,
      isOutlined: false,
      style: {
        margin: 'auto',
        backgroundColor: '#fafaff',
        width: "".concat(boxWidthProcent, "%")
      }
    }, React.createElement("div", {
      style: {
        marginBottom: bottomMargin * 12,
        height: boxHeight * 12,
        marginTop: topMargin * 12
      }
    }))
  );
};
svs.myProfile.react.shared.components.Skeleton = Skeleton;

 })(window);